import { createTheme } from "@mui/material/styles";
import {
  CSSProperties,
  MixinsOptions,
} from "@mui/material/styles/createMixins";
import fonts from "./fonts";

type TMixinFn = {
  (...args: any): CSSProperties;
};

type TMixins = MixinsOptions & {
  [k: symbol | string]: CSSProperties | TMixinFn;
};

export const theme = createTheme({
  mixins: {
    flexCenterV: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    border: (borderColor: string, borderRadius = 10) => ({
      border: `1px solid ${borderColor}`,
      borderRadius,
    }),
  } as TMixins,
  breakpoints: {
    values: {
      xs: 370,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "Josefin Sans",
    subtitle1: {
      fontFamily: "Josefin Sans",
      color: "#DCDCDC",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        root: {
          "@font-face": fonts,
          fontFamily: "Josefin Sans",
          fontSize: "9rem",
          color: "#FFFFFF",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          border: "1px solid #FFB965",
          borderRadius: 20,
          fontSize: 13,
          padding: "7px 29px",
          color: "#FFFFFF",
          background: "transparent",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: '0.8rem',
          color: "#FFFFFF",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "red",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#202342",
    },
    secondary: {
      main: "#3B368C",
    },
    warning: {
      main: "#FFB965",
    },
    background: {
      default: "#202342",
    },
  },
});

export type Theme = typeof theme;
